import api from "@/api";
import moment from "moment";
import * as _ from "lodash";

export default {
  data() {
    return {
      globalLoadingColor: this.$constants.LOADING_COLOR,
      globalLoading: false,
      Toast: this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        showCloseButton: true,
        timer: 3000
      })
    };
  },
  computed: {
    $currentUser() {
      return this.$store.getters["user/currentUser"];
    },
    $currentUID() {
      return this.$store.getters["user/currentUID"];
    },
    $UserDetails() {
      return this.$store.getters["user/details"];
    },
    $Permissions() {
      return this.$store.getters["permissions/permissions"];
    },
    $currentRole() {
      return this.$store.getters["user/currentUserRoleId"];
    },
    $myShift() {
      return this.$store.getters["user/myShift"];
    },
    $orderAccess() {
      return this.$store.getters["permissions/orderAccess"];
    },
    $currentUserRoles() {
      return this.$store.getters["user/currentUserRoles"];
    },
    $OrdersList() {
      return this.$store.getters["orders/ordersList"];
    },
    $OrdersListFilter() {
      return this.$store.getters["orders/ordersFilter"];
    },
    $userSettings() {
      return this.$store.getters['user/userSettings']
    },
    $deliveryPrices() {
      return this.$store.getters["orders/deliveryPrices"];
    },
    $runners() {
      return this.$store.getters["platform/runners"];
    },
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
    $ActiveNotifications() {
      return this.$store.getters['platform/activeNotifications']
    },
    $PlatformUsersData() {
      return this.$store.getters['platform/usersData']
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
    $dynamicData() {
      return this.$store.getters['platform/dynamicData']
    },
  },
  methods: {
    async getUserData(id) {
      if (this.$PlatformUsersData[id] && this.$PlatformUsersData[id].id) {
        return this.$PlatformUsersData[id];
      }
      if (!this.$PlatformUsersData[id] || !this.$PlatformUsersData[id].isLoading) {
        const arr = {};
        arr[id] = {isLoading: true};
        this.$store.dispatch('platform/setUsersData', {...this.$PlatformUsersData, ...arr});
        const {data} = await api.index('/new/users/' + id);
        if (data.success) {
          if (data.user) {
            arr[id] = data.user;
            await this.$store.dispatch('platform/setUsersData', {...this.$PlatformUsersData, ...arr});
            return this.$PlatformUsersData[id];
          }
        }
      }
      return new Promise((resolve, reject) => {
        let zombieCounter = 0;
        let checking = setInterval(() => {
          ++zombieCounter;
          if (this.$PlatformUsersData[id].id || zombieCounter > 10) {
            clearInterval(checking);
            resolve(this.$PlatformUsersData[id]);
          }
        }, 1000);
      });
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async mixinUpdateOrdersByType() {
      const ordersTypes = {
        manual: 0,
        delivery: 1,
        post: 2
      };
      // console.log(this.$OrdersListFilter, this.$OrdersList);
      let type;
      if (
        this.$OrdersListFilter &&
        this.$OrdersListFilter.typeAlias &&
        ordersTypes[this.$OrdersListFilter.typeAlias] !== undefined
      ) {
        type = ordersTypes[this.$OrdersListFilter.typeAlias];
        this.globalLoading = true;
        let {data} = await api.index("/orders/getOrdersByType/" + type);
        if (data.success) {
          let allOrders =
            typeof this.$OrdersList === "object" ? {...this.$OrdersList} : {};
          allOrders[type] = data.orders;
          // this.$store.dispatch("orders/setOrdersFilter", {typeAlias: Object.keys(this.ordersTypes).find((t) => this.ordersTypes[t] === type)});
          this.$store.dispatch("orders/setOrdersList", {...allOrders});
        }
        this.globalLoading = false;
      }
    },
    isAllowToShow(type = null) {
      let result = false;
      switch (type) {
        case 'noSMSUpdate':
          if (+this.$ActiveNotifications.noSMSUpdate) {
            const arr = ["supervisor", 'managerAssist', "manager"];
            if (this.$currentRole === "admin") return true;
            if (this.$currentUserRoles) {
              this.$currentUserRoles.forEach(roleName => {
                if (arr.includes(roleName)) result = true;
              });
            }
          }
          break;
      }
      return result;
    },
    openInNewPage(name, params) {
      // console.log(name, params);
      const routeData = this.$router.resolve({name, params});
      // console.log(routeData);
      if (params && params.ordersId) {
        routeData.href = routeData.href + '?ordersId=' + params.ordersId.join(',');
      }
      window.open(routeData.href, "_blank");
    },
    mixinGoToRouter(name, params = null, e = null) {
      if (e) e.stopPropagation();
      // document.querySelector('body').style.overflow = 'auto';
      const body = document.getElementsByTagName("body")[0];
      body.style.overflow = "auto";
      if (params) {
        // if (this.shallowEqual(params, this.$route.params)) {
        // this.$router.go(this.$router.currentRoute);
        // params.reload = true;
        // }else {
        this.$router.push({name, params});
        // }
      } else {
        this.$router.push({name});
      }
    },
    displayDrugs(details, type = null, options = {}, printCostPrice = true) {
      let text = "";
      if (!details) return text;
      details.forEach((d, key) => {
        if (d.drug) {
          text +=
            '<div class="drug_price_details"><p>' +
            d.drug.prep +
            " (" +
            d.drug.id +
            ")</p>";

          if (d.drug.komplekt != 1) {
            let setPrice = d.price * d.drug.komplekt;
            text +=
              "<p><strong>" +
              d.qty / d.drug.komplekt +
              "</strong> (компл) * <strong>" +
              setPrice +
              "</strong></p>";
            text +=
              "<p><strong>" +
              d.qty +
              "</strong> завод упак. * <strong>" +
              d.price +
              '</strong>' +
              (printCostPrice ? '(<span class="trx7">' +
                d.cost_price +
                "</span>)" : '') + "</p>";
          } else {
            text +=
              "<p><strong>x " +
              d.qty +
              "</strong> * <strong>" +
              d.price +
              '</strong>' +
              (printCostPrice ? '<span class="trx7">' +
                d.cost_price +
                "</span>)" : '') + "</p>";
          }

          if (false && this.type == "storeDetailed") {
            // let inStoreWInvoices = this.inStoreWInvoices && this.inStoreWInvoices[d.drug_id] ? +this.inStoreWInvoices[d.drug_id] : 0;
            let toSend =
              this.availableToSend && this.availableToSend[d.drug_id]
                ? +this.availableToSend[d.drug_id]["calculatedNum"]
                : 0;
            if (this.disableSupplyDrugs) toSend = 0;

            let autoListNum =
              this.availableToSend && this.availableToSend[d.drug_id]
                ? +this.availableToSend[d.drug_id]["autoListNum"]
                : 0;
            let confirmed =
              this.confirmedDrugs && this.confirmedDrugs[d.drug_id]
                ? +this.confirmedDrugs[d.drug_id]
                : 0;
            let transitIn =
              this.drugsTransits &&
              this.drugsTransits[d.drug_id] &&
              this.drugsTransits[d.drug_id].in
                ? +this.drugsTransits[d.drug_id].in
                : 0;
            let transitOut =
              this.drugsTransits &&
              this.drugsTransits[d.drug_id] &&
              this.drugsTransits[d.drug_id].out
                ? +this.drugsTransits[d.drug_id].out
                : 0;
            let inSendStore =
              this.inSendStore && this.inSendStore[d.drug_id]
                ? this.inSendStore[d.drug_id]
                : 0;

            let inStore =
              (this.inStore && this.inStore[d.drug_id]
                ? +this.inStore[d.drug_id]
                : 0) - transitIn;

            let calculation1 = confirmed - inStore - transitIn;
            let calculation2 = inSendStore;
            let prepareToSendDebug = calculation1 + " / " + calculation2;
            let prepareToSend =
              calculation1 < calculation2 ? calculation1 : calculation2;
            if (prepareToSend < 0) prepareToSend = 0;

            let allowTosend = toSend > autoListNum ? autoListNum : toSend;
            if (allowTosend < 0) allowTosend = 0;

            let title1 = "";
            let title2 = "";
            if (this.$currentRole == "admin") {
              title1 =
                toSend +
                " / " +
                autoListNum +
                " первая цифра - наличие на Родительском Складе - транзиты с РС + транзиты на РС - бронь почта -  согласованная бронь всех складов 3 уровня, кроме склада получателя (СПБ, ЕКБ, СМР, СРТ, ЧЛБ, НСБ, ТМН, КРС), которая не закрывается этими складами и транзитами на эти склады - согласованная бронь МСК  (в тч назначены курьеру); вторая цифра - цифра  из автосписка";
              title2 =
                prepareToSendDebug +
                " первая цифра: просчитываем  обязательную необходимость склада получателя: забронировано/подтверждено (согласовано) - наличие склада получателя - в дороге на склад-получатель. Вторая цифра: просчитываем то, что теоретически можем отправить со склада отправителя: наличие склада Москвы Москва - статусы 1,2 city = 0 (почта) - статус 2 city = 1 (МСК, у курьера) - invoices с Москвы в статусе 2 (дорога)";
            }

            text +=
              '<p class="extra_info">динамический остаток (свободных упак.): <strong>' +
              (inStore + allowTosend + transitIn - confirmed) +
              "</strong></p>";
            text +=
              '<p class="extra_info">всего в распоряжении упак.: <strong>' +
              (inStore + allowTosend + transitIn) +
              "</strong> (из них на складе " +
              inStore;
            if (transitIn) text += ", в дороге на склад " + transitIn;
            if (!(toSend == 0 && autoListNum == 0)) {
              text +=
                ', <span class="w_title" title="' +
                title1 +
                '"> возможно отправить ' +
                allowTosend +
                "</span>)</p>";
            } else {
              text += ")";
            }
            if (confirmed)
              text +=
                '<p class="extra_info">забронировано/подтверждено: <strong>' +
                confirmed +
                "</strong></p>";

            if (
              prepareToSend ||
              (prepareToSend == 0 && this.$currentRole == "admin")
            )
              text +=
                '<p class="extra_info w_title" title="' +
                title2 +
                '">Готовим к отправке с ближайшим трансфером: <strong>' +
                prepareToSend +
                "</strong></p>";
          }

          if (this.type == "storeDetailed") {
            if (
              this.drugDynamicStoreData &&
              this.drugDynamicStoreData[d.drug_id]
            )
              text +=
                '<div class="store_info">' +
                "<p>Динамический остаток: <strong>" +
                this.drugDynamicStoreData[d.drug_id].dynamicStore +
                "</strong></p>" +
                "<p>Всего в распоряжении: <strong>" +
                this.drugDynamicStoreData[d.drug_id].inUse +
                "</strong> (их них на складе: " +
                this.drugDynamicStoreData[d.drug_id].inStore;
            if (this.drugDynamicStoreData[d.drug_id].transitIn) {
              text +=
                ", в дороге: " + this.drugDynamicStoreData[d.drug_id].transitIn;
            }
            if (this.drugDynamicStoreData[d.drug_id].allowToSend)
              text +=
                ", возможно отправить: " +
                this.drugDynamicStoreData[d.drug_id].allowToSend;
            text += ")</p>";

            text +=
              "<p>Согласовано: <strong>" +
              this.drugDynamicStoreData[d.drug_id].confirmed.total +
              "</strong></p>";
            if (this.drugDynamicStoreData[d.drug_id].confirmed.daughter) {
              text += " (";
              if (this.drugDynamicStoreData[d.drug_id].confirmed.current) {
                text +=
                  "текущий склад: " +
                  this.drugDynamicStoreData[d.drug_id].confirmed.current +
                  ", ";
              }
              text +=
                "дочерние склады: " +
                this.drugDynamicStoreData[d.drug_id].confirmed.daughter +
                ")";
            }
            if (this.drugDynamicStoreData[d.drug_id].readyToSend) {
              text +=
                "<p>Готовим к отправке: <strong>" +
                this.drugDynamicStoreData[d.drug_id].readyToSend +
                "</strong></p>";
            }
            text += "</div>";
          }
          text += "</div>";
          if (key !== details.length - 1)
            text += '<hr class="divider_of_drug_prices">';
        }
      });
      return text;
    },
    $allowTo(detailAlias, value = null) {
      const detail = this.$UserDetails.find((d) => d.alias === detailAlias);
      if (detail) {
        return detail.details;
      }
      return false;
    },
    $can(permissionName, showForAdmin = true) {
      // console.log(permissionName, this.$currentRole);
      // console.log(permissionName, this.$Permissions, (this.$Permissions || []).indexOf(permissionName));
      //TODO block persanaly permissions require
      switch (permissionName) {
        case 'runners/storeStatus':
          if ([50, 217, 218].includes(this.$currentUID)) return false;
          break;
      }
      if (showForAdmin && this.$currentRole === "admin") return true;
      return (this.$Permissions || []).indexOf(permissionName) !== -1;
    },
    shallowEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }

      return true;
    },
    mixinPrintOrderNum(num) {
      return (num + "").slice((num + "").length - 5);
    },
    mixinPrintPhone(phone, dial = false) {
      // console.log(phone);
      let phoneText = "";
      let phoneNum = phone;
      if (!phoneNum) return phoneNum;
      if (phoneNum.substring(0, 2) === "00") {
        phoneNum = phoneNum.slice(2);
      }
      phoneText += '-' + phoneNum.slice(-2);
      phoneText = '-' + phoneNum.substring((phoneNum.length - 4), (phoneNum.length - 2)) + phoneText;
      phoneText = '-' + phoneNum.substring((phoneNum.length - 7), (phoneNum.length - 4)) + phoneText;
      phoneText = '+' + phoneNum.substring(0, (phoneNum.length - 7)) + phoneText;

      return dial ? phoneText.replace(/-/g, '') : phoneText;

      if (phoneNum.substring(0, 2) !== "00") {
        phoneNum = '00' + phoneNum;
      }
      if (phoneNum.substring(0, 3) === "0007") {
        phoneText +=
          "8-" +
          phoneNum.substring(3, 6) +
          "-" +
          phoneNum.substring(6, 9) +
          "-" +
          phoneNum.substring(9, 11) +
          "-" +
          phoneNum.substring(11);
      } else {
        phoneText +=
          "+" +
          phoneNum.substring(2, 5) +
          "-" +
          phoneNum.substring(5, 7) +
          "-" +
          phoneNum.substring(7, 10) +
          "-" +
          phoneNum.substring(10, 12) +
          "-" +
          phoneNum.substring(12);
      }
      // console.log(phoneText, phoneText.replaceAll('-', ''));
      return dial ? phoneText.replace(/-/g, '') : phoneText;
      // return dial ? phoneText.replaceAll('-', '') : phoneText;
    },
    mixinIsAllowToEditOrder(order, view = true) {
      // if (this.$currentRole == "admin") return true;
      // console.log(order, this.$orderAccess);
      if (!this.$orderAccess || !Object.keys(this.$orderAccess).length) return false;
      if ((this.$orderAccess.all && this.$orderAccess.all.all)
        || (this.$orderAccess.all && this.$orderAccess.all[order.city_id])
        || (this.$orderAccess[order.site_id] && this.$orderAccess[order.site_id].all)
        || (this.$orderAccess[order.site_id] && this.$orderAccess[order.site_id][order.city_id])) {
        if ((view ? [9999, 0, 1, 8] : [9999, 0, 8]).includes(+order.status)) {
          return true;
        }
      }
      return false;
    },
    mixinGetDivisionName(div) {
      let name = '';
      if (div?.title) {
        return div.title;
      }
      (div?.cities ?? []).forEach((c, i) => {
        name += c.city && c.city.name || 'Почта';
        if ((i + 1) !== div.cities.length) {
          name += ', ';
        }
      })
      return name;
    },
    mixinGetCityNameByOrder(order) {
      const div = this.$AllDivisions[order.division_id];
      const city = div.cities.find((c) => c.object_id === order.city_id);
      if (city) {
        return city.city.name;
      }
      return 'не найден город';
    },
    printDate(date, format = 'DD.MM.YYYY HH:mm', timestamp = false, utc = 3) {
      if (!date) return moment().format(format);
      // console.log(date, +utc, moment.utc(date));
      // if (utc) {
      if (timestamp) return moment.utc(date).format(format);

      const newDate = moment.utc(date);
      return newDate.utcOffset(+utc).format(format);
      // if (utc < 0) {
      //   return newDate.subtract(Math.abs(utc), 'hours').format(format);
      // }
      // if (utc > 0) {
      //   return newDate.add(utc, 'hours').format(format);
      // }
      // }
      return moment.utc(date).format(format);
      // if (!date) return moment().utcOffset(180).format(format);
      // return moment(date).utcOffset(180).format(format);
    },
    async mixinGetOrderDeliveryPrices() {
      if (!this.$deliveryPrices) {
        const {data} = await api.index('/settings/orders/deliveryPrice');
        if (data.success) {
          await this.$store.dispatch('orders/setDeliveryPrices',
            data.records.reduce((acc, r) => {
              if (!acc[r.site_id]) acc[r.site_id] = {};
              acc[r.site_id][r.city_id] = {...r};
              return acc;
            }, {}));
          await this.$store.dispatch('orders/setOrdersInProgress',
            (data.ordersInProgress || []).reduce((acc, r) => {
              if (!acc[r.division_id]) acc[r.division_id] = {};
              acc[r.division_id][r.dDate] = {...r};
              return acc;
            }, {}));
        }
      }
    },
    printPackSet(qty, record) {
      if (!qty) return;
      if (+record.pack_set !== 1) {
        return `${qty} з.у. [${Math.round(qty / +record.pack_set * 10) / 10}к.]`;
      } else {
        return qty % 1 === 0 ? Math.round(qty) : qty;
      }
    },
    async mixinGetOrderRunners() {
      if (!this.$runners) {
        const {data} = await api.index('/settings/runners');
        if (data.success) {
          await this.$store.dispatch('platform/setRunners', data.records);
        }
      }
    },
    sortArray(arr, filed, direction = 'asc') {
      return _.orderBy(arr, filed, direction);
    },
    mixinGetSortedDivisions(line = null, type = 1) {
      let arr = [];
      const allDivisions = Object.values(this.$AllDivisions).filter((d) => d.type === type);
      if (line) {
        switch (line) {
          case 1:
            arr.push({...allDivisions.find((d) => d.id === 1)});
            arr.push({...allDivisions.find((d) => d.id === 4)});
            arr.push({...allDivisions.find((d) => d.id === 7)});
            break;
          case 2:
            arr = _.orderBy(allDivisions.filter((d) => d.is_active && d.cities[0]?.object_id === 1 && ![1].includes(d.id)), 'title');
            break;
          case 3:
            arr = _.orderBy(allDivisions.filter((d) => d.is_active && d.cities[0]?.object_id !== 1 && ![1, 4, 7].includes(d.id)), 'title');
            break;
          case -1:
            arr = _.orderBy(allDivisions.filter((d) => !d.is_active && d.status === 2), 'title');
            break;
          default:
            break;
        }
        return arr;
      }
      arr.push({...allDivisions.find((d) => d.id === 1)});
      arr.push({...allDivisions.find((d) => d.id === 7)});
      arr.push({...allDivisions.find((d) => d.id === 4)});
      let divisions = allDivisions.reduce((acc, d) => {
        if (d && ![1, 4, 7].includes(d.id) && d.is_active) {
          acc.push({...d, storeName: this.$AllStores[d.stores[0]?.object_id].short_title});
        }
        return acc;
      }, []);
      arr = [...arr, ..._.orderBy(divisions, 'storeName')];
      return arr;
    },
    mixinIsAllowToView(object) {
      switch (object) {
        case 'orderSaleData':
          // $currentUserRoles
          if (this.$currentRole === 'admin') {
            return true;
          }
          break;
      }
      return false;
    },
    printOrderStatus(order) {
      let statuses = {
        0: {status: "primary", title: "С сайта"},
        9999: {status: "success", title: "Ручная"},
        1: {status: "info", title: "Обработана"},
        2: {status: "info", title: "Назначена"},
        5: {status: "info", title: "Сгруппирована"},
        8: {status: "info", title: "Спрос"},
        9: {status: "info", title: "предварительная"},
        3: {status: "success", title: "Закрыта"},
        11: {status: "success", title: "Доставлена"},
        "-2": {status: "warning", title: "Отказ у менеджера"},
        "-3": {status: "warning", title: "Отказ у курьера"},
        "10000": {status: "info", title: "Архив"}
      };
      let className = "";
      let statusTitle = order.status;
      if (statuses[order.status]) {
        className = statuses[order.status].status;
        statusTitle = statuses[order.status].title;
      }
      return (
        '<span class="badge badge-' + className + '">' + statusTitle + "</span>"
      );
    },
    mixinGetProfitFigures(priceData, preset) {
      // console.log(priceData, preset);
      // let price = priceData.costPrice * priceData.pack_set * +(preset && preset.calculatedRate || 0);
      // price += (price * +(preset && preset.baseMargin || 0) / 100) + +(preset && preset.delivery || 0)
      // price += (price * (preset && preset.deliveryPercent || 0) / 100);
      // return Math.round(price * 100) / 100;

      let costPrice = priceData.costPrice * priceData.pack_set * (preset.calculatedRate || 0);
      let setPrice = +priceData.price - (+priceData.price * +(preset.deliveryPercent || 0) / (100 + (preset.deliveryPercent || 0))) - +(preset.delivery || 0);
      const percent = Math.round(setPrice * 100 / costPrice) - 100;
      return percent;
    },
    isMobile() {
      return screen.width <= 760;
    },
    openOrderToEdit(id) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id})
    },
    mixinOpenDrawer(data) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data
        // callBackAction: 'refreshList'
      })
    },
    getSumByCurrency(sum, currencyId, toCurrencyId = null) {
      if (!toCurrencyId) toCurrencyId = this.$platformConstants.operationCurrency.id;
      switch (+currencyId) {
        case this.$platformConstants.allowSalaryCurrencies[40].id:
          return sum / this.$AllCurrencies[41].rate;
        default:
          return sum * this.$AllCurrencies[28].rate / this.$AllCurrencies[toCurrencyId].rate
      }
    },
    printInvoiceStatus(invoice) {
      const statuses = {
        1: {title: 'предварительная'},
        2: {title: 'в дороге'},
        0: {title: 'доставлена'},
        3: {title: 'модерация'},
        4: {title: 'сборка'},
        5: {title: 'резерв'}
      };
      return statuses[invoice.status]?.title;
    }
  }
};
